<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <b-card>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                        <i class="fa fa-fw fa-edit mr-2" />Detail Request Edit
                        Emas
                    </h5>
                    <div v-if="canApprove(data.status)" class="d-flex">
                        <b-button
                            variant="success"
                            @click="acceptRequest()"
                            class="mr-2"
                        >
                            <i class="fa fa-check mr-2" /> Approve
                        </b-button>
                        <b-button variant="danger" @click="rejectRequest()">
                            <i class="fa fa-times mr-2" /> Reject
                        </b-button>
                    </div>
                </div>
                <hr />

                <!-- Detail Utama -->
                <b-row v-if="data">
                    <b-col md="6">
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td width="180">No. Faktur PGI</td>
                                <td>
                                    :
                                    <strong>{{
                                        data.no_faktur_pgi || "-"
                                    }}</strong>
                                </td>
                            </tr>

                            <tr>
                                <td>Status Request</td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getStatusBadge(data.status)[0]
                                        "
                                    >
                                        {{ getStatusBadge(data.status)[1] }}
                                    </b-badge>
                                </td>
                            </tr>
                            <tr v-if="data.variance_id">
                                <td>Temuan Emas</td>
                                <td>
                                    :
                                    <b-badge
                                        href="#"
                                        @click.prevent="
                                            $router.push(
                                                '/emas/temuan/' +
                                                    data.variance_id
                                            )
                                        "
                                        variant="info"
                                        class="text-white cursor-pointer"
                                    >
                                        <i class="fa fa-external-link mr-1"></i>
                                        Lihat Temuan
                                    </b-badge>
                                </td>
                            </tr>
                            <tr v-if="data.variance_id">
                                <td>Status Temuan</td>
                                <td>
                                    :
                                    <b-badge
                                        :variant="
                                            getVarianceStatusBadge(
                                                data.variance_status
                                            )[0]
                                        "
                                        :class="
                                            data.variance_status === 3 ||
                                            data.variance_status === 4
                                                ? 'text-white'
                                                : ''
                                        "
                                    >
                                        {{
                                            getVarianceStatusBadge(
                                                data.variance_status
                                            )[1]
                                        }}
                                    </b-badge>
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    data.status === STATUS_RESET.REJECTED &&
                                        data.reject_note
                                "
                            >
                                <td>Alasan Penolakan</td>
                                <td>
                                    : <strong>{{ data.reject_note }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>Kategori</td>
                                <td>
                                    : <strong>{{ data.category || "-" }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>Catatan Temuan</td>
                                <td class="text-break">
                                    : {{ data.notes || "-" }}
                                </td>
                            </tr>
                        </table>
                    </b-col>
                    <b-col md="6">
                        <table class="table table-borderless table-sm">
                            <tr>
                                <td width="180">Dibuat Oleh</td>
                                <td>: {{ data.created_by || "-" }}</td>
                            </tr>
                            <tr>
                                <td>Dibuat Pada</td>
                                <td>
                                    : {{ $helper.parseDate(data.created_at) }}
                                    {{
                                        $helper.parseHourMinute(data.created_at)
                                    }}
                                </td>
                            </tr>
                            <tr v-if="data.processed_by">
                                <td>Diproses Oleh</td>
                                <td>: {{ data.processed_by || "-" }}</td>
                            </tr>
                            <tr v-if="data.processed_at">
                                <td>Diproses Pada</td>
                                <td>
                                    : {{ $helper.parseDate(data.processed_at) }}
                                    {{
                                        $helper.parseHourMinute(
                                            data.processed_at
                                        )
                                    }}
                                </td>
                            </tr>
                        </table>
                    </b-col>
                </b-row>

                <!-- Perbandingan Layout -->
                <b-card class="border mt-3 mb-3">
                    <b-row>
                        <!-- Kolom Data Lama -->
                        <b-col md="6" class="border-right">
                            <h6 class="font-weight-bold mb-3">
                                <i class="fa fa-arrow-left mr-2 text-danger" />Data Lama
                            </h6>
                            <table class="table table-sm mb-0">
                                <tr>
                                    <td width="150">Jenis</td>
                                    <td>: {{ data.item_kind || "-" }}</td>
                                </tr>
                                <tr>
                                    <td>Merk</td>
                                    <td>: {{ data.item_brand || "-" }}</td>
                                </tr>
                                <tr>
                                    <td>Tipe</td>
                                    <td>: {{ data.item_type || "-" }}</td>
                                </tr>
                                <tr>
                                    <td>Kadar XRF</td>
                                    <td class="text-right">
                                        <strong>{{ data.purity }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Berat Kotor</td>
                                    <td class="text-right">
                                        <strong
                                            >{{ data.dry_weight }} gr</strong
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td>Potongan</td>
                                    <td class="text-right">
                                        <strong
                                            >{{
                                                data.weight_reduction
                                            }}
                                            gr</strong
                                        >
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Tipe Emas</td>
                                    <td class="text-right">
                                        {{ data.gold_type || "-" }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Merk Cap Emas</td>
                                    <td class="text-right">
                                        {{ data.gold_mint_mark || "-" }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Ada Cap</td>
                                    <td class="text-right">
                                        {{
                                            data.has_mark ? "Ada" : "Tidak Ada"
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Cap Getok</td>
                                    <td class="text-right">
                                        {{
                                            data.is_stamped
                                                ? "Ada"
                                                : "Tidak Ada"
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Jumlah Keping</td>
                                    <td class="text-right">
                                        {{ data.piece_count || "-" }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.LM_SCAN
                                    "
                                >
                                    <td>Tahun</td>
                                    <td class="text-right">
                                        {{ data.year || "-" }}
                                    </td>
                                </tr>
                            </table>
                        </b-col>

                        <!-- Kolom Data Baru -->
                        <b-col md="6">
                            <h6 class="font-weight-bold mb-3">
                                <i class="fa fa-arrow-right mr-2 text-success" />Data Baru
                            </h6>
                            <table class="table table-sm mb-0">
                                <tr>
                                    <td width="150">Jenis</td>
                                    <td>: <span :class="{'text-success font-weight-bold': isChanged('item_kind', 'new_item_kind')}">{{ data.new_item_kind || "-" }}</span></td>
                                </tr>
                                <tr>
                                    <td>Merk</td>
                                    <td>: <span :class="{'text-success font-weight-bold': isChanged('item_brand', 'new_item_brand')}">{{ data.new_item_brand || "-" }}</span></td>
                                </tr>
                                <tr>
                                    <td>Tipe</td>
                                    <td>: <span :class="{'text-success font-weight-bold': isChanged('item_type', 'new_item_type')}">{{ data.new_item_type || "-" }}</span></td>
                                </tr>

                                <tr>
                                    <td>Kadar XRF</td>
                                    <td class="text-right">
                                        <strong :class="{'text-success': isChanged('purity', 'new_purity')}">{{ data.new_purity }}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Berat Kotor</td>
                                    <td class="text-right">
                                        <strong :class="{'text-success': isChanged('dry_weight', 'new_dry_weight')}"
                                            >{{ data.new_dry_weight }} gr</strong
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td>Potongan</td>
                                    <td class="text-right">
                                        <strong :class="{'text-success': isChanged('weight_reduction', 'new_weight_reduction')}"
                                            >{{
                                                data.new_weight_reduction
                                            }}
                                            gr</strong
                                        >
                                    </td>
                                </tr>

                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Tipe Emas</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('gold_type', 'new_gold_type')}">{{ data.new_gold_type || "-" }}</span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Merk Cap Emas</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('gold_mint_mark', 'new_gold_mint_mark')}">{{ data.new_gold_mint_mark || "-" }}</span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Ada Cap</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('has_mark', 'new_has_mark')}">{{
                                            data.new_has_mark ? "Ada" : "Tidak Ada"
                                        }}</span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Cap Getok</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('is_stamped', 'new_is_stamped')}">{{
                                            data.new_is_stamped
                                                ? "Ada"
                                                : "Tidak Ada"
                                        }}</span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.PERHIASAN
                                    "
                                >
                                    <td>Jumlah Keping</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('piece_count', 'new_piece_count')}">{{ data.new_piece_count || "-" }}</span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        data.new_item_kind_id ===
                                            ITEM_KIND.LM_SCAN
                                    "
                                >
                                    <td>Tahun</td>
                                    <td class="text-right">
                                        <span :class="{'text-success font-weight-bold': isChanged('year', 'new_year')}">{{ data.new_year || "-" }}</span>
                                    </td>
                                </tr>
                            </table>
                        </b-col>
                    </b-row>
                </b-card>

                <!-- Media Bukti -->
                <b-row class="mt-3">
                    <b-col md="12">
                        <b-card
                            header="Media Bukti (Foto / Video)"
                            class="border mb-3"
                        >
                            <div
                                v-if="data.media && data.media.length > 0"
                                class="d-flex flex-wrap"
                            >
                                <div
                                    v-for="(url, index) in data.media"
                                    :key="index"
                                    class="mr-2 mb-2 bg-light rounded position-relative"
                                >
                                    <a :href="url" target="_blank">
                                        <div v-if="isVideo(url)">
                                            <video
                                                :src="url"
                                                class="media-thumbnail"
                                                preload="metadata"
                                            ></video>
                                            <div
                                                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; pointer-events: none;"
                                            >
                                                <i class="fa fa-play"></i>
                                            </div>
                                        </div>
                                        <b-img-lazy
                                            v-else
                                            :src="url"
                                            class="media-thumbnail"
                                            alt="Media Reset"
                                        />
                                    </a>
                                </div>
                            </div>
                            <span v-else class="text-muted"
                                >Tidak ada bukti media.</span
                            >
                        </b-card>
                    </b-col>
                </b-row>

                <!-- History Logs -->
                <b-row v-if="data.logs && data.logs.length > 0">
                    <b-col md="12">
                        <h6 class="font-weight-bold mb-3">Log Aktivitas</h6>
                        <hr style="border: none; border-top: 1px solid #ddd;" class="mb-4" />
                        <div class="activity-feed">
                            <div
                                v-for="(log, idx) in data.logs"
                                :key="idx"
                                class="feed-card mb-3 p-3 rounded border"
                                :class="getLogActionDetails(log.action).border"
                            >
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="font-weight-bold mb-0 text-dark" style="font-size: 0.95rem;">
                                        {{ getLogActionDetails(log.action).text }}
                                    </h6>
                                    <span class="small text-muted font-weight-bold">
                                        {{ $helper.parseDate(log.created_at) }} {{ $helper.parseHourMinute(log.created_at) }}
                                    </span>
                                </div>
                                <div class="small text-muted">
                                    Diproses oleh: <span class="font-weight-bold text-secondary">{{ log.performed_by || "-" }}</span>
                                </div>
                                <div v-if="log.note" class="feed-note mt-2 p-2 rounded text-break">
                                    {{ log.note }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </div>

        <!-- Modal Tolak (Reject Modal) -->
        <b-modal
            id="m-reject-request"
            title="Tolak Request Edit Emas"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @hidden="clearRejectForm"
        >
            <b-form-group label-class="font-weight-bold">
                <template #label>
                    Alasan Penolakan <span style="color: red;">*</span>
                </template>
                <b-form-textarea
                    v-model="rejectForm.reject_note"
                    placeholder="Masukkan alasan penolakan"
                    rows="3"
                    maxlength="255"
                />
                <small class="text-muted">
                    {{
                        rejectForm.reject_note
                            ? rejectForm.reject_note.length
                            : 0
                    }}
                    / 255
                </small>
            </b-form-group>
            <div class="text-right mt-3">
                <b-button
                    variant="secondary"
                    @click="$bvModal.hide('m-reject-request')"
                    class="mr-2"
                >
                    Batal
                </b-button>
                <b-button
                    variant="danger"
                    :disabled="isSubmitting"
                    @click="submitRejectRequest"
                >
                    {{ isSubmitting ? "Memproses..." : "Tolak Request" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnumPermission from "@/shared/enum-permissions";

const STATUS_RESET = Object.freeze({
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3
});

const ITEM_KIND = Object.freeze({
    PERHIASAN: 257,
    LM_RETRO: 261,
    LM_SCAN: 251
});

export default {
    data() {
        return {
            STATUS_RESET,
            ITEM_KIND,
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,
            data: {},
            rejectForm: {
                reject_note: ""
            }
        };
    },
    methods: {
        isChanged(oldKey, newKey) {
            if (!this.data) return false;
            return this.data[oldKey] != this.data[newKey];
        },
        canApprove(status) {
            return (
                status === STATUS_RESET.PENDING &&
                this.hasPermission(EnumPermission.APPROVE_RESET_INVENTORY_GOLD)
            );
        },
        init() {
            this.initStatus = 0;
            this.getItems();
        },
        getItems() {
            this.isBusy = true;
            return this.$axios
                .get(`gold-reset-requests/${this.$route.params.id}`)
                .then(res => {
                    this.data = res.data.data;
                    this.initStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        hasPermission(permissionId) {
            return (
                this.$helper.checkRoleNumber(
                    permissionId.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        getStatusBadge(status) {
            switch (status) {
                case STATUS_RESET.PENDING:
                    return ["warning", "PENDING"];
                case STATUS_RESET.APPROVED:
                    return ["success", "DITERIMA"];
                case STATUS_RESET.REJECTED:
                    return ["danger", "DITOLAK"];
                default:
                    return ["light", "-"];
            }
        },
        getVarianceStatusBadge(status) {
            switch (status) {
                case 1:
                    return ["warning", "MENUNGGU PENERIMAAN"];
                case 2:
                    return ["secondary", "MENUNGGU AUDIT"];
                case 3:
                    return ["primary", "DISETUJUI AUDIT"];
                case 4:
                    return ["info", "DALAM DISKUSI"];
                case 99:
                    return ["success", "SELESAI"];
                default:
                    return ["light", "-"];
            }
        },
        processRequest(status, rejectNote = null) {
            this.isSubmitting = true;
            const payload = { status };
            if (rejectNote) {
                payload.reject_note = rejectNote;
            }

            this.$axios
                .post(`gold-reset-requests/${this.data.id}/process`, payload)
                .then(() => {
                    const isApprove = status === STATUS_RESET.APPROVED;
                    this.$helper.toastSuccess(
                        this,
                        isApprove
                            ? "Request berhasil diapprove!"
                            : "Request berhasil ditolak!"
                    );
                    if (!isApprove) {
                        this.$bvModal.hide("m-reject-request");
                    }
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },
        acceptRequest() {
            let isConfirmed = confirm(
                `Lakukan approval untuk request edit NF ${
                    this.data.no_faktur_pgi
                }?`
            );
            if (!isConfirmed) return;

            this.processRequest(STATUS_RESET.APPROVED);
        },
        rejectRequest() {
            this.rejectForm.reject_note = "";
            this.$bvModal.show("m-reject-request");
        },
        clearRejectForm() {
            this.rejectForm.reject_note = "";
        },
        submitRejectRequest() {
            const note = this.rejectForm.reject_note
                ? this.rejectForm.reject_note.trim()
                : "";
            if (!note) {
                this.$helper.toastError(this, "Alasan penolakan wajib diisi!");
                return;
            }
            if (note.length > 255) {
                this.$helper.toastError(
                    this,
                    "Alasan penolakan maksimal 255 karakter!"
                );
                return;
            }

            this.processRequest(STATUS_RESET.REJECTED, note);
        },
        isVideo(url) {
            if (!url) return false;
            const ext = url
                .split("?")[0]
                .split(".")
                .pop()
                .toLowerCase();
            return ["mp4", "webm", "ogg", "quicktime", "mov"].includes(ext);
        },
        getLogActionDetails(action) {
            const map = {
                CREATE_REQUEST: { text: "Membuat Request", class: "bg-primary", border: "feed-card-primary" },
                APPROVE_REQUEST: { text: "Menyetujui Request", class: "bg-success", border: "feed-card-success" },
                REJECT_REQUEST: { text: "Menolak Request", class: "bg-danger", border: "feed-card-danger" }
            };
            return map[action] || { text: action, class: "bg-secondary", border: "feed-card-secondary" };
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>
.media-thumbnail {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
}

.media-thumbnail:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-color: #adb5bd;
}

.activity-feed {
    padding: 2px;
}
.feed-card {
    background-color: #fff;
    transition: transform 0.15s ease-in-out;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
.feed-card:hover {
    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
}
.feed-card-primary { border-left: 4px solid #007bff !important; }
.feed-card-success { border-left: 4px solid #28a745 !important; }
.feed-card-danger { border-left: 4px solid #dc3545 !important; }
.feed-card-secondary { border-left: 4px solid #6c757d !important; }

.feed-note {
    background-color: #f8f9fa;
    border-left: 3px solid #adb5bd;
    font-size: 0.88rem;
    color: #495057;
}
</style>
